import type { ReactNode } from 'react';
import { EmptyState, IconShield } from '@bala/ui';
import type { Resource } from '@bala/core';
import { useAuth } from '../auth';

/**
 * Garde de route : refuse l'écran si aucun des domaines n'est accessible en
 * lecture. Complète le filtrage de la barre de navigation (deep links).
 */
export function RequireAccess({
  resource,
  anyOf,
  children,
}: {
  resource?: Resource;
  anyOf?: Resource[];
  children: ReactNode;
}) {
  const auth = useAuth();
  const allowed = anyOf?.length
    ? anyOf.some((entry) => auth.can(entry, 'read'))
    : resource
      ? auth.can(resource, 'read')
      : true;

  if (!allowed) {
    return (
      <EmptyState
        icon={<IconShield size={28} />}
        title="Accès restreint"
        description="Votre compte n'a pas accès à cet onglet. Demandez à un Baygon d'ajuster vos permissions."
      />
    );
  }

  return <>{children}</>;
}
